import Icon from '../../components/Icon'

Icon.register({
  'brands/behance-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6 0.1 30.3 7.8 30.3 27.5zM178.8 210.7c0 16.3-10.7 22.9-25.8 22.9h-42.7v-44.8h39.6c15.2 0 28.9 4.2 28.9 21.9zM311.1 233.9c19.2 0 28.8 11.2 30.5 29.7h-62.2c1.2-18.3 13.4-29.7 31.7-29.7zM448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8v18.9zM228.7 295.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5h-90.5v192h93.1c34.9-0.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c0.1-2.3 0.3-4.8 0.3-7.2z'
      }
    ]
  }
})
